import { TagCondition, TagQuery } from '../services/http/documents.api';

export const buildTagQuery = (tagList: TagCondition[][]): TagQuery => (
  {
    operator: 'AND' as const,
    children: tagList.map((tags) => ({
      operator: 'OR' as const,
      children: tags,
    })),
  }
);

export const buildTagList = (tagQuery: TagQuery): TagCondition[][] => (
  (tagQuery.children as TagQuery[]).map(({ children }) => children as TagCondition[])
);

export default {
  buildTagQuery,
  buildTagList,
};
